import {MapControl, MapControlProps, withLeaflet} from "react-leaflet";
import L from "leaflet";

interface RoadSegmentsButtonProps extends MapControlProps {
    toggleShowRoadSegments: Function,
    showRoadSegments: boolean
}

class RoadSegmentButton extends MapControl<RoadSegmentsButtonProps, L.Control.EasyButton> {

    createLeafletElement(props: RoadSegmentsButtonProps): L.Control.EasyButton {
        return new L.Control.EasyButton({
            id: 'toggleShowRoadSegmentsBtn',
            states: [
                {
                    stateName: 'disabled',
                    icon: 'fas fa-road inactive',
                    title: 'Vis vegnett',
                    onClick: () => {
                        this.props.toggleShowRoadSegments();
                    }
                },
                {
                    stateName: 'enabled',
                    icon: 'fas fa-road active',
                    title: 'Skjul vegnett',
                    onClick: () => {
                        this.props.toggleShowRoadSegments();
                    }
                }
            ]
        });
    }

    componentDidUpdate() {
        this.leafletElement.state(this.props.showRoadSegments ? 'enabled' : 'disabled');
    }

}

export default withLeaflet(RoadSegmentButton);